export default["__VITE_ASSET__DsTYIxlI__","__VITE_ASSET__P$ONyq7q__"];